import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export interface CarrierPackagingType {
  packagingMaterial: string;
  displayName: string;
}

export const packagingTypes = {
  search: {
    queryKey: 'carrier-service/packaging-types',
    configurationType: 'cached' as const,
    fn: async () => {
      const { data } = await GatewayAxiosClient.get<CarrierPackagingType[]>(
        '/carrier-proxy/api/v1/carriers/packaging/types',
      );

      return data;
    },
  },
};
